<div class="loan-app-quotes">
    <div *ngIf="(currentPreApprovedPricing$ | async)">
        <div style="display: flex; flex-direction: row" *ngIf="lgvUserSvc.IsDLR || lgvUserSvc.IsCK">
            <fa-icon style="color: #FFA030; margin-right: 15px; margin-top: 15px;"
                icon="triangle-exclamation"></fa-icon>
            <p>The Deal Desk has completed their analysis <a (click)="goToVault()">(View in Vault)</a> and selected
                pre-approved programs below. Review and submit
                pre-approved quotes to your clients now. All initial pricing quotes will be archived once pre-approved
                pricing is
                shared.</p>
        </div>


        <button class="btn btn-primary" (click)="goToPricingPage()">Go to Pricing</button>

    </div>

    <div class="row">
        <mat-checkbox [formControl]="viewArchivedLoansCtrl">View Archived Loans</mat-checkbox> &nbsp;
    </div>
    <div class="Vert-20"></div>
    <ng-container *ngIf="(pricingScenariosForLoan$ | async)?.length > 0; else noScenarios">
        <div class="info-container" style="display: flex; flex-direction: row;"
            *ngIf="!lgvPricingSvc.isLockRequestAllowed()">
            <div>
                <h5>
                    <fa-icon style="color:#FF9B06" icon="triangle-exclamation"> </fa-icon> &nbsp; Lock Request Unavailable
                </h5>
                <p>The market is closed and lock requests cannot be submitted at this time. The loan quotes will show updated pricing
                    when
                    the market reopens after 9:30am EST.</p>
                <p>{{ currentDate | date: 'M/d/y h:mm a'}}</p>
            </div>
            <!-- <div style="align-self: center; margin-left: auto;">
                <button class="btn btn-outline" style="padding: 10px 15px;" (click)="lgvPricingSvc.notifyFoLockRequest()">
                    <fa-icon icon="bell-ring"> </fa-icon>Notify Me
                </button>
            </div>         -->
        </div>
        <div class="Vert-20"></div>
        <ng-container *ngFor="let scenario of (pricingScenariosForLoan$ | async); let i = index">
            <ng-container *ngIf="viewArchivedLoansCtrl?.value || (scenario?.status?.name != 'Archived')">
                <lgv-scenario-info-card [pricingScenario]="scenario" sourcePage="LoanPipeline"
                    [expanded]="i == 0"></lgv-scenario-info-card>
            </ng-container>

        </ng-container>
    </ng-container>
    <ng-template #noScenarios>
        <ng-container *ngIf="!(currentPreApprovedPricing$ | async)">
            <p>There are no pricing quotes for this loan.</p>
            <button class="btn btn-primary" (click)="goToPricingPage()">Price</button>
        </ng-container>
    </ng-template>
</div>